import { Button, InfoPage, isLoggedIn } from "@shapr3d/frontend-lib";

import useNavigation from "../../hooks/navigation";
import useTranslation from "../../hooks/useTranslation";

function VerifyEmailError() {
  const navigation = useNavigation();
  const { t, m } = useTranslation();
  const buttonText = isLoggedIn() ? t(m.Account.BackToAccount) : t(m.Account.BackToLogin);
  function navigateOnClick() {
    isLoggedIn() ? navigation.goToProfile() : navigation.goToSignIn();
  }

  return (
    <InfoPage
      variant="warning"
      title={t(m.Account.InvalidLink)}
      description={t(m.Account.InvalidLinkDescription)}
      primaryCTA={<Button onClick={navigateOnClick}>{buttonText}</Button>}
    />
  );
}

export default VerifyEmailError;
